import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/masterPortrait/banner.jpg'
// import navColor from '../../assets/masterPortrait/nav/color.png'
import navBg from '../../assets/masterPortrait/nav/nav_bg.jpg'

import far1 from '../../assets/masterPortrait/nav/far1.png'
import far1_active from '../../assets/masterPortrait/nav/far1_active.png'
import far2 from '../../assets/masterPortrait/nav/far2.png'
import far2_active from '../../assets/masterPortrait/nav/far2_active.png'
import son1 from '../../assets/masterPortrait/nav/son1.png'
import son1_active from '../../assets/masterPortrait/nav/son1_active.png'
import son2 from '../../assets/masterPortrait/nav/son2.png'
import son2_active from '../../assets/masterPortrait/nav/son2_active.png'
import son3 from '../../assets/masterPortrait/nav/son3.png'
import son3_active from '../../assets/masterPortrait/nav/son3_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(84),
    // backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(84),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(2)} ${calcRemFn(58)} 0 ${calcRemFn(69)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(83),
    height: calcRemFn(40)
  },
  bottomBtnLayout: {
    paddingLeft: calcRemFn(5),
    justifyContent: 'center'
  },
  bottomBtnBaseCss: {
    width: calcRemFn(83),
    height: calcRemFn(30.5)
  }
}

const navData = {
  // masterPortraitSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
    ],
  }
}
// 肖像照-单人-93475
// 肖像照-情侣-93517
// 肖像照-闺蜜-93523

const pictureList = [
  {
    key: '1_',
    top: 1,
    bottom: 1,
    picNum: 14,
    pid: 93475
  },
  {
    key: '2_',
    top: 1,
    bottom: 2,
    picNum: 10,
    pid: 93517
  },
  {
    key: '3_',
    top: 1,
    bottom: 3,
    picNum: 6,
    pid: 93523
  },
  {
    key: '4_',
    top: 2,
    bottom: 1,
    picNum: 2,
    pid: 93475
  },
  {
    key: '5_',
    top: 2,
    bottom: 2,
    picNum: 2,
    pid: 93517
  },
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, top, bottom} = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/masterPortrait/ctn/${key}${index + 1}.jpg`))
    })
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${top}_i${bottom}`,
      farName: `top${top}`,
      sonName: `_i${bottom}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)
const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: '大师肖像照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
